import React from "react";
import noFound from "../assets/imgs/svgs/404 Error-pana.svg";

const Pagenotfound = () => {
  return (
    <section className="min-h-screen flex items-center justify-center bg-gray-800 px-4">
      <div className="text-center max-w-lg animate-fadeIn">
        <img
          src={noFound}
          alt="404 Illustration"
          className="w-full max-w-sm mx-auto drop-shadow-md animate-popIn"
        />

        <h1 className="text-4xl font-bold mt-6 text-gray-800">
          Page Not Found
        </h1>

        <p className="text-gray-300 mt-3 text-lg">
          The page you are looking for doesn’t exist.
        </p>

        <a
          href="/"
          className="inline-block mt-6 px-6 py-3 rounded-xl bg-orange-500 text-white font-semibold 
          hover:bg-orange-400 transition-all shadow-lg hover:shadow-xl"
        >
          Go Back Home
        </a>
      </div>
    </section>
  );
};

export default Pagenotfound;
